import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import messages from './messages';
import styles from './NotFoundPage.module.scss';
import Button from 'components/Buttons/Button';
import { PAGE_NOT_FOUND } from '../../constants';
import { WELCOME } from '../../routes';

export function NotFound() {
  const { formatMessage } = useIntl();
  const history = useHistory();

  useEffect(() => {
    document.title = PAGE_NOT_FOUND;
  }, []);

  return (
    <div>
      <Helmet>
        <title>404 - React Boilerplate</title>
      </Helmet>
      <main className={styles.container}>
        <h1 className={styles.title}>ooops this page does not exist</h1>
        <Button
          title={formatMessage(messages.backLink)}
          className={styles.button}
          handleClick={() => history.push(WELCOME)}
        />
      </main>
    </div>
  );
}

export default NotFound;
